import { render, staticRenderFns } from "./app-header-dropdown-menu.vue?vue&type=template&id=cdd10a18&"
import script from "./app-header-dropdown-menu.vue?vue&type=script&lang=ts&"
export * from "./app-header-dropdown-menu.vue?vue&type=script&lang=ts&"
import style0 from "./app-header-dropdown-menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports